export const name = "TO_HEX";
export const summary = `Converts a \`BYTES\` value to a hexadecimal \`STRING\` value.`;
export const reference = `
## TO_HEX

Converts a \`BYTES\` value to a hexadecimal \`STRING\` value.

\`\`\`
TO_HEX(bytes)
\`\`\`

### Description

Converts a sequence of \`BYTES\` into a hexadecimal \`STRING\`. Converts each byte in the \`STRING\` as two hexadecimal characters in the range\`(0..9, a..f)\`. To convert a hexadecimal-encoded\`STRING\` to \`BYTES\`, use FROM_HEX.


### Return type

\`STRING\`


### Example



\`\`\`
SELECT
  b'\\x00\\x01\\x02\\x03\\xAA\\xEE\\xEF\\xFF' AS byte_string,
  TO_HEX(b'\\x00\\x01\\x02\\x03\\xAA\\xEE\\xEF\\xFF') AS hex_string

/*----------------------------------+------------------*
 | byte_string | hex_string |
 +----------------------------------+------------------+
 | \\x00\\x01\\x02\\x03\\xaa\\xee\\xef\\xff | 00010203aaeeefff |
 *----------------------------------+------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
